<template>
  <app-layout title="Dashboard">
    <template v-slot:sidenav></template>

    <div class="flex h-[calc(100vh-66px)] overflow-hidden">
      <!-- Left sidebar -->
      <div class="w-[22%] h-full border-r overflow-hidden">
        <Whatsapp @unread="handleUnreadItem" @startchat="startnewchat" @contactSelected="newcontactSelected"
          :receivedValue="sharedValue" @view-profile="handleViewProfile" ref="whatsAppRef" class="h-full" />
      </div>

      <!-- Main chat area -->
      <div class="flex-1 h-full overflow-hidden">
        <WhatsappScreen v-if="chatSelected" @messageSent="handleSendMessage" :receivedValue="sharedValue"
          ref="whatsAppScreenRef" class="h-full" />
        <Default v-else class="h-full" />
      </div>

      <!-- Right sidebar -->
      <transition name="slide-left" mode="out-in">
        <div v-show="showProfile" class="w-[22%] h-full border-l overflow-hidden">
          <WhatsappSide @contactsaved="handleconversationlist" :receivedValue="sharedValue" class="h-full" @close-profile="showProfile = false"/>
        </div>
      </transition>
    </div>
  </app-layout>
</template>


<script>
import { ref, onMounted, nextTick } from 'vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import Whatsapp from "./Whatsapp.vue";
import WhatsappScreen from "./WhatsappScreen.vue";
import Default from "./Default.vue";
import WhatsappSide from "./WhatsappSide.vue";

export default {
  components: {
    AppLayout,
    Whatsapp,
    WhatsappScreen,
    WhatsappSide,
    Default,
  },

  setup() {
    const whatsAppRef = ref(null);
    const whatsAppScreenRef = ref(null);
    const showProfile = ref(false);

    // Shared state and data
    const chatSelected = ref(false);
    const sharedValue = ref('');
    const handleViewProfile = (item) => {
      sharedValue.value = item;
      showProfile.value = true;
      console.log("✅ view-profile received in parent:", item);
    };
    // Methods
    const handleUnreadItem = async (phone_no) => {
      console.log("✅ 'unread' event received from child:", phone_no);
      sharedValue.value = phone_no;
      chatSelected.value = true;
      console.log("Chat selected with phone_no:", sharedValue.value);

      // Ensure DOM updates and the component is rendered
      await nextTick();
      if (whatsAppScreenRef.value) {
        whatsAppScreenRef.value.fetchMessages();
      } else {
        console.error("whatsAppScreenRef is not available.");
      }
    };

    const startnewchat = async (phoneNumber) => {
      sharedValue.value = phoneNumber;
      chatSelected.value = true;
      console.log("Chat selected with phone number:", sharedValue.value);

      await nextTick();
      if (whatsAppScreenRef.value) {
        whatsAppScreenRef.value.fetchMessages();
        whatsAppRef.value.fetchUnreadConversation();
      } else {
        console.error("whatsAppScreenRef is not available.");
      }
    };

    const newcontactSelected = async (contact) => {
      console.log("Contact selected:", contact);
      sharedValue.value = contact;
      chatSelected.value = true;

      await nextTick();
      if (whatsAppScreenRef.value) {
        whatsAppScreenRef.value.fetchMessages();
      } else {
        console.error("whatsAppScreenRef is not available.");
      }
    };

    const handleSendMessage = () => {
      if (whatsAppRef.value) {
        whatsAppRef.value.fetchUnreadConversation();
      } else {
        console.error("whatsAppRef is not available.");
      }
    };

    const handleconversationlist = () => {
      if (whatsAppRef.value) {
        whatsAppRef.value.fetchUnreadConversation();
      } else {
        console.error("whatsAppRef is not available.");
      }
    };

    // Ensuring that the ref is available after the component is mounted
    onMounted(() => {
      if (!whatsAppRef.value) {
        console.error("whatsAppRef is null on mounted");
      }
    });

    return {
      whatsAppRef,
      whatsAppScreenRef,
      chatSelected,
      sharedValue,
      showProfile,
      handleViewProfile,
      handleUnreadItem,
      startnewchat,
      newcontactSelected,
      handleSendMessage,
      handleconversationlist,
      handleViewProfile
    };
  },
};
</script>

<style>
/* Ensure the application takes up full height without scrolling */
html,
body {
  height: 100%;
  overflow: hidden;
}

/* Add specific component scrolling where needed */
.scrollable-content {
  height: 100%;
  overflow-y: auto;
}

.custom-grid {
  display: grid;
  grid-template-columns: 25fr 50fr 25fr;
  /* 2.5/10, 5/10, 2.5/10 ratio */
}
/* Slide from right to left */
html,
body {
  height: 100%;
  overflow: hidden;
}

/* Add specific component scrolling where needed */
.scrollable-content {
  height: 100%;
  overflow-y: auto;
}

.custom-grid {
  display: grid;
  grid-template-columns: 25fr 50fr 25fr;
  /* 2.5/10, 5/10, 2.5/10 ratio */
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform, opacity;
}

.slide-left-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-enter-to,
.slide-left-leave-from {
  transform: translateX(0);
  opacity: 1;
}
</style>